import { Flex } from 'antd';
import styled from 'styled-components';
import { ImageContainer as CommonImageContainer } from '../../styles/commonStyles';

export const Section = styled.section`
  padding: 24px;
  background: #fff;
`;

export const BottomActionBar = styled.div`
  position: sticky;
  bottom: -24px;
  left: 0;
  right: 0;
  padding: 16px 24px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  z-index: 10;
`;

export const ImageContainer = styled(CommonImageContainer)`
  width: 100%;
  height: 200px;
`;

export const DeleteButton = styled.div`
  padding: 12px;
  cursor: pointer;
  font-size: 18px;
  color: #999;
  :hover {
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;
